/**
 * Enumération des types de message de notification
 */
export enum TypeMessageNotif {
    /** Message courrier (email) */
    EMAIL = 'M',

    /** Message de confirmation */
    CONFIRMATION = 'C'
}